module.exports = __webpack_public_path__ + "fb-tutorial-5-pl.png?624536c6b6954b88915ab314e16d0741";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/fb-tutorial-5-pl.png
// module id = 9Wne
// module chunks = 50